import api from '../services/api';
import { IHoliday } from '../shared/interfaces';

interface IResponseGetGuideStatus {
  data: IHoliday[];
  count: number;
}
export const getHolidays = async (
  take: number,
  skip: number,
  keyword?: string,
): Promise<IResponseGetGuideStatus> => {
  const response = await api.post('/holidays/list', {
    take,
    skip,
    keyword,
  });
  return response.data;
};

export const postHoliday = async (payload: any): Promise<IHoliday> => {
  const response = await api.post(`/holidays`, payload);
  return response.data;
};

export const patchHoliday = async (
  id: string | undefined,
  payload: any,
): Promise<IHoliday> => {
  if (!id) {
    throw new Error('ID do feriado não fornecido.');
  }
  const response = await api.patch(`/holidays/${id}`, payload);
  return response.data;
};

export const getSelectHolidays = async (): Promise<IHoliday[]> => {
  const response = await api.get('/holidays/select/all');
  return response.data;
};
